'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.helpCenter',
dependencies:['ui.router'],
configs:[
require('./helpCenterConfig')],

components:[
require('./helpCenterController')]});
//# sourceMappingURL=index.js.map
